export const CONTENT_PREMIUM = '/premium';
export const CONTENT_HELP = '/content/help/FtFQ2uTbG5lYHsIjy6PpM';
export const CONTENT_PRIVACY = '/content/help/2lRv0hwHQ7MqETHZ0i76EB';
export const CONTENT_TERMS = '/content/help/5w8CjWHqT7J2OH72u3nqI7';
export const CONTACT_US = '/contactus';
export const APPLE_STORE_APP = 'https://itunes.apple.com/us/app/golf-handicapp/id1459228624?ls=1&mt=8';
export const GOOGLE_PLAY_APP = 'https://play.google.com/store/apps/details?id=com.awl.golfhandicapp';
export const CONTENT_PAYPAL_CANCEL = '/cancel';
export const CONTENT_PAPAL_THANKS = '/thankyou';
export const CONTENT_DONATE = '/donate';